const Projects = ()=>{
    return(
        <>
            <h1>Content</h1>
        </>
    )
}

export default Projects;